import React, { useEffect, useState } from "react";
import { supabase } from "../../supabase/client";
import DataList from "../common/DataList";
import Loading from "../common/Loading";
import Input from "../common/Input";
import Modal from "../common/Modal";
// import { selectRowsFn } from "@tanstack/react-table";
// import { SelectObjectContentCommand } from "@aws-sdk/client-s3";
import { useLogin } from "../../context/LoginContext";

const tipoDocumentos = [
  { value: "1", label: "Cartas" },
  { value: "2", label: "Escritos" },
  { value: "3", label: "Resoluciones" },
];

const NotificationForm = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [filterForm, setFilterForm] = useState(false);
  const [tipoDocumento, setTipoDocumento] = useState(null);
  const [documentProcess, setDocumentProcess] = useState([]);
  const [infoPerson, setInfoPerson] = useState(null);
  const [expedientes, setExpedientes] = useState([]);
  const [results, setResults] = useState([]);
  const [selectedExp, setSelectedExp] = useState("");
  // const [selectedRows, setSelectedRows] = useState([]);
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [selectedFilter, setSelectedFilter] = useState("");
  const [formData, setFormData] = useState([]);
  const [loading, setLoading] = useState(false);

  const { user } = useLogin();

  useEffect(() => {
    getExpedientes();
    // handleSearchDocuments();
  }, []);

  const getExpedientes = async () => {
    // const { error, data } = await supabase.from("process").select(`
    //         id,
    //         num_process,
    //         anio_process,
    //         class_process(name)
    //         .eq
    //         }
    //    `);
    // if (error) throw error.message;
    // const expedientesData = data.map((item) => {
    //   return {
    //     value: item.id,
    //     label:
    //       item.num_process +
    //       "-" +
    //       item.anio_process +
    //       "-" +
    //       item.class_process.name,
    //   };
    // });
    // setExpedientes(expedientesData);
    const data = await fetch(
      "https://arbitrajeccia.com.pe/sistema/restallfiles"
    );
    const expedientesData = await data.json();
    if (expedientesData.code !== 200) {
      alert("Error al cargar expedientes");
      return;
    }
    const expedientesFormat = expedientesData.data.map((item) => {
      return {
        value: item.iddatos_caso,
        label:
          item.numero_expediente_nro +
          "-" +
          item.numero_expediente_anio +
          "-" +
          item.numero_expediente_letras,
      };
    });
    setExpedientes(expedientesFormat);
  };

  const handleSearchDocuments = async () => {
    setLoading(true);
    setInfoPerson(null);
    if (!formData.process_id) {
      alert("Debe seleccionar un tipo de documento y un expediente");
      setLoading(false);
      return;
    }
    const files = await fetch(
      `https://arbitrajeccia.com.pe/sistema/restallfiles/${formData.process_id}`
    );
    const filesData = await files.json();
    if (filesData.code !== 200) {
      alert("Error al cargar documentos");
      setLoading(false);
      return;
    }
    const filesFormat = filesData.data.map((item) => {
      return {
        type: item.type,
        date: item.date.split(" ")[0],
        url: item.file_path,
        label: item.file.split("/").pop(),
      };
    });
    filesFormat.sort((a, b) => {
      // La función de comparación para ordenar por fecha
      const dateA = new Date(a.date);
      const dateB = new Date(b.date);
      return dateB - dateA;
    });
    setDocumentProcess(filesFormat);
    setResults(filesFormat);
    setLoading(false);

    // if (infoPerson === null) {
    //   const { data: dataPerson, error: errorPerson } = await supabase
    //     .from("process")
    //     .select(
    //       `
    //   demanding:demanding_id (
    //       id,
    //       name,
    //       email
    //   ),
    //   defendant:defendant_id (
    //       id,
    //       name,
    //       email
    //   )
    //   `
    //     )
    //     .eq("id", formData.process_id)
    //     .single();

    //   if (errorPerson) console.log("error", errorPerson);
    //   const dataPersonFormat = {
    //     demanding: dataPerson.demanding,
    //     defendant: dataPerson.defendant,
    //   };
    //   setInfoPerson(dataPersonFormat);
    // } else {
    //   setInfoPerson(infoPerson);
    // }
    // if (formData.tipoDocumento === "1") {
    //   const { data, error } = await supabase
    //     .from("letters")
    //     .select("id, detail, file")
    //     .eq("process_id", formData.process_id);
    //   if (error) console.log("error", error);
    //   const dataFormat = data.map((item) => {
    //     return {
    //       id: item.id,
    //       url: item.file,
    //       label: item.detail,
    //     };
    //   });
    //   setDocumentProcess(dataFormat);
    //   setLoading(false);
    // }
    // if (formData.tipoDocumento === "2") {
    //   const { data, error } = await supabase
    //     .from("writings")
    //     .select(`id`)
    //     .eq("process_id", formData.process_id)
    //     .single();
    //   if (error) console.log("error", error);

    //   if (data) {
    //     const { data: dataDoc, error: errorDoc } = await supabase
    //       .from("written_documents")
    //       .select(
    //         `
    //         id,
    //         name,
    //         file
    //       `
    //       )
    //       .eq("writings_id", data.id);
    //     if (errorDoc) console.log("error", errorDoc);

    //     const dataFormat = dataDoc.map((item) => {
    //       return {
    //         id: item.id,
    //         url: item.file,
    //         label: item.name,
    //       };
    //     });
    //     setDocumentProcess(dataFormat);
    //   }
    //   setLoading(false);
    //   // console.log("first",dataFormat);
    // }
    // if (formData.tipoDocumento === "3") {
    //   setLoading(false);
    // }
  };

  // const handleCheckboxChange = (id) => {
  //   const selectedRowIds = [...selectedRows];
  //   const index = selectedRowIds.indexOf(id);

  //   if (index !== -1) {
  //     selectedRowIds.splice(index, 1);
  //   } else {
  //     selectedRowIds.push(id);
  //   }
  //   setSelectedRows(selectedRowIds);
  // };

  const handleCheckboxChangeFiles = (id) => {
    const selectedRowIds = [...selectedFiles];
    const index = selectedRowIds.indexOf(id);

    if (index !== -1) {
      selectedRowIds.splice(index, 1);
    } else {
      selectedRowIds.push(id);
    }
    setSelectedFiles(selectedRowIds);
  };

  // console.log(selectedRows)

  const handleDataListChange = (e, name) => {
    setFormData(() => ({
      ...formData,
      [name]: e.value,
    }));
  };
  const handleOpenModalNotificaction = () => {
    setIsModalOpen(true);
  };
  // console.log(selectedFiles)
  const handleSendNotification = async () => {
    setLoading(true);
    setIsModalOpen(false);
    // if (selectedRows.length === 0) {
    //   alert("Debe seleccionar al menos un documento");
    //   return;
    // }
    // if (!formData.message) {
    //   alert("Debe ingresar un mensaje");
    //   return;
    // }
    // if (!formData.aditional) {
    //   alert("Debe ingresar un correo adicional");
    //   return;
    // }

    const fd = new FormData();
    fd.append("user_email", user.email);
    fd.append("message", formData.message.replace(/\n/g, "<br>"));
    fd.append("aditional", formData.aditional);
    fd.append("subject", formData.subject);
    // fd.append("document_ids", selectedRows);
    fd.append("files_ids", selectedFiles);
    // fd.append("demanding_id", infoPerson.demanding.id)
    // fd.append("defendant_id", infoPerson.defendant.id)
    // fd.append("tipoDocumento", formData.tipoDocumento)
    console.log(user.email, formData.message, formData.aditional, formData.subject, selectedFiles)


    // fetch(
    //   "https://arbitrajeccia.com.pe/sistema/api/send_email_notification.php",
    //   {
    //     method: "POST",
    //     body: fd,
    //   }
    // )
    //   .then((response) => response.json())
    //   .then((data) => {
    //     if (data.status === 500) {
    //       alert(data.message);
    //       return;
    //     }
        
    //     setFormData({});
    //     setSelectedFiles([]);
    //     setLoading(false);
    //     alert(data.message);
    //   })
    //   .catch((error) => {
    //     console.error("Error:", error);
    //   });
  };
  // console.log(infoPerson);
  return (
    <>
      {loading && <Loading />}
      <form>
        <p>Selecciona el expediente para realizar la busqueda</p>
        <div className="grid grid-cols-3 gap-10 mt-5">
          <div className="col-span-2">
            <DataList
              textLabel={"Expediente"}
              name={"process_id"}
              className="w-3/4"
              value={selectedExp}
              dataOptions={expedientes}
              onChange={(e) => {
                handleDataListChange(e, "process_id");
                const filterData = expedientes.filter(
                  (item) => item.value === e.value
                );
                setSelectedExp(filterData[0]);
              }}
            />
          </div>
          <button
            type="button"
            onClick={async () => {
              await handleSearchDocuments();
            }}
            //   disabled={!pdfLinks}
            className="py-2 px-4 bg-primary text-white rounded-md"
          >
            Seleccionar
          </button>
          {/* <DataList
            textLabel={"Tipo"}
            name={"tipoDocumento"}
            className="w-3/4"
            value={tipoDocumento}
            dataOptions={tipoDocumentos}
            onChange={async (e) => {
              handleDataListChange(e, "tipoDocumento");
              setTipoDocumento(e);
            }}
          /> */}
        </div>
        {/* <div className="grid grid-cols-3 gap-10 mt-5"> */}
        <div className="mt-5 h-[200px] overflow-y-scroll border border-gray-300 rounded-lg">
          <table className="min-w-full">
            <thead className="sticky top-0 bg-white">
              <tr>
                <th className="py-2 px-4 border-b text-left">Seleccionar</th>
                <th className="py-2 px-4 border-b text-left flex items-center gap-x-1 relative">
                  Tipo
                  <svg
                    onClick={() => setFilterForm(!filterForm)}
                    className="w-5 cursor-pointer"
                    viewBox="-5.5 0 32 32"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path d="M8.48 25.72c-.16 0-.32-.04-.44-.12a.894.894 0 0 1-.4-.72v-8.72L.16 7.68c-.2-.24-.28-.6-.12-.88s.44-.48.76-.48h19.8c.32 0 .64.2.76.48.12.32.08.64-.12.92l-7.8 8.8v6.32c0 .32-.2.6-.48.76l-4.08 2c-.08.08-.24.12-.4.12zM2.64 7.96l6.48 7.32c.12.16.2.36.2.56v7.64l2.4-1.2V16.2c0-.2.08-.4.2-.56l6.8-7.68H2.64z" />
                  </svg>
                  {filterForm && (
                    <div className="flex items-center gap-x-1 absolute top-10 left-0 z-10 p-2 bg-white shadow-md border rounded-sm">
                      <select
                        className="p-1 text-xs rounded-lg border"
                        onChange={(e) => {
                          setSelectedFilter(e.target.value);
                        }}
                      >
                        <option value="">Seleccionar</option>
                        <option value="CARTAS">Cartas</option>
                        <option value="ESCRITOS">Escritos</option>
                        <option value="RESOLUCIONES">Resoluciones</option>
                        <option value="NOTIFICACIONES">Notificaciones</option>
                      </select>
                      <button
                        className="bg-primary text-white py-1 px-2 rounded-lg text-xs"
                        type="button"
                        onClick={() => {
                          const filterData = documentProcess.filter(
                            (item) => item.type === selectedFilter
                          );
                          setResults(filterData.sort((a, b) => a.date - b.date));
                          setFilterForm(false);
                        }}
                      >
                        Filtrar
                      </button>
                    </div>
                  )}
                </th>
                <th className="py-2 px-4 border-b text-left">Fecha</th>
                <th className="py-2 px-4 border-b text-left">Documentos</th>
              </tr>
            </thead>
            <tbody>
              {results.map((row, index) => (
                <tr key={index}>
                  <td className="py-2 px-4 border-b">
                    <input
                      type="checkbox"
                      checked={selectedFiles.includes(row.url)}
                      onChange={() => handleCheckboxChangeFiles(row.url)}
                    />
                  </td>
                  <td className="py-2 px-4 border-b">{row.type}</td>
                  <td className="py-2 px-4 border-b">{row.date}</td>
                  <td className="py-2 px-4 border-b">
                    <a
                      href={`${row.url}`}
                      className="underline hover:text-primary transition-colors duration-300"
                    >
                      {row.label}
                    </a>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        {/* </div> */}
        {/* <div className="h-[150px] overflow-y-scroll border border-gray-300 rounded-lg mt-5">
          <table className="min-w-full">
            <thead>
              <tr>
                <th className="py-2 px-4 border-b text-left">Seleccionar</th>
                <th className="py-2 px-4 border-b text-left">Nombre</th>
                <th className="py-2 px-4 border-b text-left">Mail</th>
                <th className="py-2 px-4 border-b text-left">Tipo</th>
              </tr>
            </thead>
            {infoPerson && (
              <tbody>
                <tr>
                  <td className="py-2 px-4 border-b">
                    <input
                      type="checkbox"
                      checked={selectedRows.includes(
                        infoPerson.demanding.email
                      )}
                      onChange={() =>
                        handleCheckboxChange(infoPerson.demanding.email)
                      }
                    />
                  </td>
                  <td className="py-2 px-4 border-b">
                    {infoPerson.demanding.name}
                  </td>
                  <td className="py-2 px-4 border-b">
                    {infoPerson.demanding.email}
                  </td>
                  <td className="py-2 px-4 border-b">Demandante</td>
                </tr>
                <tr>
                  <td className="py-2 px-4 border-b">
                    <input
                      type="checkbox"
                      checked={selectedRows.includes(
                        infoPerson.defendant.email
                      )}
                      onChange={() =>
                        handleCheckboxChange(infoPerson.defendant.email)
                      }
                    />
                  </td>
                  <td className="py-2 px-4 border-b">
                    {infoPerson.defendant.name}
                  </td>
                  <td className="py-2 px-4 border-b">
                    {infoPerson.defendant.email}
                  </td>
                  <td className="py-2 px-4 border-b">Demandado</td>
                </tr>
              </tbody>
            )}
          </table>
        </div> */}
        <Input
          textLabel="Asunto"
          name="subject"
          className="w-3/4 mt-5"
          placeholder="Ejem. Exp. 100-2021-TA-CCIA ..."
          value={formData.subject || ""}
          onChange={(e) => {
            setFormData(() => ({
              ...formData,
              subject: e.target.value,
            }));
          }}
        />
        <Input
          textLabel="Correos electrónicos"
          name="aditional"
          className="w-3/4 mt-5"
          placeholder="Ingrese correos adicionales separados por coma"
          value={formData.aditional || ""}
          onChange={(e) => {
            setFormData(() => ({
              ...formData,
              aditional: e.target.value,
            }));
          }}
        />
        <h4 className="text-base text-zinc-600/80 font-semibold mb-1 mt-3">
          Mensaje
        </h4>
        <div className="grid grid-cols-1 gap-x-10 gap-y-2 mt-4 items-start">
          <textarea
            className="w-full appearance-none text-sm border border-gray-300 focus:border-gray-400 rounded-lg py-2 px-3 text-gray-500 leading-tight focus:outline-none font-normal"
            name="message"
            rows={4}
            value={formData.message || ""}
            onChange={(e) => {
              setFormData(() => ({
                ...formData,
                message: e.target.value,
              }));
            }}
          />
        </div>
        <button
          type="button"
          onClick={handleOpenModalNotificaction}
          //   disabled={!pdfLinks}
          className="py-2 px-4 bg-primary text-white rounded-md block w-full mt-5"
        >
          Enviar
        </button>
      </form>
      <Modal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        title={"Información de mensaje"}
        modalSize="sm"
      >
        <div className="flex flex-col gap-3">
          <div>
            <label className="font-medium">Asunto:</label>
            <p>{formData.subject}</p>
          </div>
          <div>
            <label className="font-medium">Enviado a:</label>
            <p>
              {formData.aditional}
            </p>
          </div>
          <div>
            <label className="font-medium">Documentos:</label>
            {selectedFiles.map((item) => {
              return (
                <p>
                  <a
                    key={item}
                    href={`${item}`}
                    className="underline hover:text-primary transition-colors duration-300 w-full"
                  >
                    {item}
                  </a>
                </p>
              );
            })}
          </div>
          <div>
            <label className="font-medium">Mensaje:</label>
            <p>{formData.message}</p>
          </div>
          <div className="flex gap-2 justify-end">
            <button
              type="button"
              className="bg-secondary hover:bg-secondary/90 border border-secondary text-white px-3 py-1 rounded-sm flex items-center gap-1 font-light"
              onClick={() => {
                setIsModalOpen(false);
              }}
            >
              Cancelar
            </button>
            <button
              type="button"
              className="bg-primary hover:bg-primary/90 border border-primary text-white px-3 py-1 rounded-sm flex items-center gap-1 font-light"
              onClick={handleSendNotification}
            >
              Confirmar
            </button>
          </div>
        </div>
      </Modal>
    </>
  );
};

export default NotificationForm;
